module.exports = __webpack_public_path__ + "static/media/chat.9b892cae.svg";